<div class="d-flex justify-content-between align-items-center mb-3">
  <h3>My Lessons</h3>
  <button class="btn btn-outline-secondary" (click)="goChatMode()">
    Chat mode
  </button>
  <button class="btn btn-primary" (click)="addLesson()">
    Add Lesson
  </button>
  <button class="btn btn-primary" (click)="logout()">
    Log Out
  </button>

</div>

<div *ngIf="lessons.length" class="d-flex align-items-center gap-2 flex-wrap mb-2">
  <label class="mb-0 small text-muted">Show workflow</label>
  <select
    class="form-select form-select-sm w-auto"
    [(ngModel)]="lessonLifecycleFilter"
    (ngModelChange)="loadLessons()"
  >
    <option value="">All</option>
    <option value="IN_PROGRESS">In progress</option>
    <option value="RELEASED">Released</option>
    <option value="ARCHIVED">Archived</option>
  </select>
</div>

<div *ngIf="lessons.length" class="d-flex align-items-center">

  <!-- Left Arrow -->
  <button class="btn btn-light scroll-btn me-2" (click)="scrollLeft()">
    ‹
  </button>

  <!-- Scroll Container -->
  <div #scrollContainer class="lesson-scroll-container">

    <div class="lesson-card" *ngFor="let lesson of lessons">

      <div class="card h-100 shadow-sm">
        <div class="card-body d-flex flex-column">

          <h6 class="card-title lesson-title">
            {{ lesson.lessonTitle }}
          </h6>
          <h6 class="text-muted">
            Version: {{ lesson.lessonVersion || '1.0' }}
          </h6>

          <span class="badge mb-1" [ngClass]="{
                  'bg-secondary': lesson.lessonStatus === 'DRAFT',
                  'bg-info': lesson.lessonStatus === 'TOC_LOCKED',
                  'bg-success': lesson.lessonStatus === 'READY'
                }">
            {{ lesson.lessonStatus }}
          </span>

          <div class="mb-2">
            <label class="small text-muted d-block mb-0">Workflow</label>
            <select
              class="form-select form-select-sm"
              [ngModel]="lesson.lessonLifecycleStatus || 'IN_PROGRESS'"
              (ngModelChange)="onLessonLifecycleChange(lesson, $event)"
              [ngModelOptions]="{ standalone: true }"
            >
              <option value="IN_PROGRESS">In progress</option>
              <option value="RELEASED">Released</option>
              <option value="ARCHIVED">Archived</option>
            </select>
          </div>

          <div class="mt-auto">
            <div class="d-grid gap-2 lesson-card-actions">
              <button class="btn btn-primary btn-sm" type="button" (click)="editLesson(lesson.lessonId)">
                Edit
              </button>

              <button
                class="btn btn-outline-secondary btn-sm"
                type="button"
                (click)="copyLesson(lesson.lessonId)"
                title="Create a duplicate of this lesson"
              >
                Copy
              </button>

              <button
                class="btn btn-outline-warning btn-sm"
                type="button"
                (click)="clearLessonContent(lesson)"
                [disabled]="!canClearLesson(lesson)"
                [title]="clearLessonDisabledTitle(lesson)"
              >
                Clear and Recreate TOC
              </button>

              <button
                class="btn btn-outline-danger btn-sm"
                type="button"
                (click)="deleteLesson(lesson)"
                [disabled]="isLessonLinkedToProject(lesson)"
                [title]="deleteLessonDisabledTitle(lesson)"
              >
                Delete lesson
              </button>

              <button
                class="btn btn-outline-success btn-sm"
                type="button"
                (click)="generatePPT(lesson.lessonId)"
                [disabled]="pptGeneratingLessonId === lesson.lessonId"
                [title]="pptGeneratingLessonId === lesson.lessonId ? 'PPT generation in progress' : 'Generate review PPT'"
              >
                {{ pptGeneratingLessonId === lesson.lessonId ? 'Generating…' : 'Generate PPT' }}
              </button>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>

  <!-- Right Arrow -->
  <button class="btn btn-light scroll-btn ms-2" (click)="scrollRight()">
    ›
  </button>

</div>

<div *ngIf="!lessons.length && !loading" class="text-muted">
  No lessons created yet.
</div>
